import React from "react";
import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home";
import Home1 from "./Components/Home1";
import About from "./Components/About";
import Skills from "./Components/Skills";
import Projects from "./Components/Projects";
import Qualification from "./Components/Qualification";
import ContactMe from "./Components/ContactMe/ContactMe";
import Footer from "./Components/Footer";
import BottomNavbar from "./Components/Navbar/BottomNavbar";

function App() {
  return (
    <div>
      {/* Navbar */}
      <div className="border-b-2 bg-gray-50 poppins lg:fixed lg:top-0 z-10  w-full">
        <div
          className="hidden lg:flex lg:justify-between
        lg:items-center lg:w-11/12  mx-auto xl:w-9/12 py-[15px]"
        >
          <Navbar />
        </div>
      </div>
      <BottomNavbar />
      <div className="w-11/12 poppins lg:w-11/12 xl:w-9/12 mx-auto">
        {/* Home PArt Div */}
        <div id="home">
          {/* Home */}
          <div className=" lg:pt-[120px] pt-[50px] relative flex gap-4 justify-center ">
            <Home />
          </div>
          <div className="lg:hidden">
            <Home1 />{" "}
          </div>
        </div>
        <section>
          <About />
          <Skills />
          <Qualification />
          <Projects />
          <ContactMe />
        </section>
      </div>

      <Footer  />
    </div>
  );
}

export default App;
